export default "__VITE_ASSET__$AErSDcl__";